export default () => ({
    authorization: '',
    userInfo: {},
    deviceId: ''
});
